import { RequestServerClass } from '@/util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class ZyScreenServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }
  /*  风险管控  */
  // 统计数据
  public getRiskManagementCountData(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/risk/count';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 某一风险数据
  public getBYRiskLevelData(opts: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventory/getBYLevel';
    return this.rSerivce.serverObj.post(url, opts);
  }
  //  某一风险企业数据
  public getBYLevelEntAllNum(opts: any) {
    const url = serverUrl + '/api/yunnan/riskControlInventory/getCountByArea';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /*  风险管控   */

  /*  隐患排查   */
  // 排查 统计
  public getPatrolTaskCountData(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/patrol/count';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  //  隐患排查企业数据
  public getBYTaskEntAllNum(opts: any) {
    const url = serverUrl + '/api/yunnan/patrol/task/getCountByArea';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 排查 弹框列表数据
  public getPatrolTaskListData(opts: any) {
    const url = serverUrl + '/api/yunnan/patrol/task';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 整改 弹框列表 --》隐患列表
  public getViewHazardManageList(id: any) {
    const url = serverUrl + `/api/yunnan/patrolHazardCheck/getHazardManager/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 整改 统计
  public getHazardCountData(opts: any) {
    // const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/hazard';
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/hazard/count';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 整改 弹框列表数据
  public getHazardManageList(opts: object) {
    const url = serverUrl + '/api/yunnan/hazardManage';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  //  整改 企业数据
  public getBYRectifyEntAllNum(opts: any) {
    const url = serverUrl + '/api/yunnan/hazardManage/getCountByArea';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /*  隐患排查   */

  /*  危险作业  */
  // 统计数据
  public getWorkCountData(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/work/count';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 弹框列表
  public getWorkListData(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicket';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /*  危险作业  */

  /*  监测监控  */
  // 润丰
  // 获取罐 高度
  public getChemicalHeight(opts: any) {
    const url = serverUrl + '/api/yunnan/chemical-tank-radar-height-record/last';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 曲线图
  public getChemicalChangeDayRange() {
    const url = serverUrl + '/api/yunnan/chemical-tank-radar-height-record/day-trend';
    return this.rSerivce.serverObj.get(url);
  }
  // // 历史数据
  public getChemicalChangeDayRangeRecord(opts: any) {
    const url = serverUrl + '/api/yunnan/chemical-tank-radar-height-record/date-range-trend';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 百威
  //
  public getAmmoniaMonitorLast(opts: any) {
    const url = serverUrl + '/api/yunnan/ammonia-monitor-tank-data/last';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 曲线图
  public getAmmoniaMonitorDayRange() {
    const url = serverUrl + '/api/yunnan/ammonia-monitor-tank-data/day-trend';
    return this.rSerivce.serverObj.get(url);
  }
  // 曲线图
  public getAmmoniaMonitorDayRangeRecord(opts: any) {
    const url = serverUrl + '/api/yunnan/ammonia-monitor-tank-data/day-range-trend';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /*  监测监控  */

  /*  监督检查  */
  // 统计数据
  public getSecurityCheckCountData(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/security/count';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 检查数 列表
  public getSecurityCheckNumList(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check/task/executor/screen/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 检查次数企业数据
  public getBYCheckEntAllNum(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check/task/getCountByArea';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 隐患数 整改数 列表
  public getSecurityHazardOrRectifyNumList(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/screen/page';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 隐患数 整改数 企业数据
  public getBYHazardOrRectifyEntAllNum(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/getCountByArea';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 曲线图
  public getCheckDayDistributed(opts: object) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/check/day/distributed';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /*  监督检查  */

  /* 责任履职 */
  public getProfession(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v1/profession';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /* 责任履职 */
  /* 临时作业 */
  public getTemporaryWorCount(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/temporaryWork/count' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url);
  }
  /* 临时作业 */

  /* 监管对象 */
  public getRegulatedEntityCount(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/regulatedEntity/count';
    return this.rSerivce.serverObj.post(url);
  }

  public getDrawList(opts: any) {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/drawList';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /* 监管对象 */

  /* 企业 红、黄、绿 统计 */
  public getCompanyCount() {
    const url = serverUrl + '/api/yunnan/cockpit-statistics/v2/company/count';
    return this.rSerivce.serverObj.post(url);
  }
  /* 企业 红、黄、绿 统计 */

  /* 蓉创 报警信息 */
  public getAlarmStatisticList(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmStatistic';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  public getAlarmStatisticData(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmStatistic/statistic';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /* 蓉创 大屏监测监控 */
  public getCompanyAndDeviceData(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmStatistic/companyAndDevice/statistic';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 报警设备
  public getAlarmDeviceList(opts: any) {
    const url = serverUrl + '/api/yunnan/alarmDevice';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /* 蓉创 大屏监测监控 */
}
